import React, { useState } from 'react';

export const FAQ: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const faqs = [
        {
            question: 'Is NyxBot live now?',
            answer: 'Not yet - this is a pre-commit phase. If we hit 500+, we build.'
        },
        {
            question: 'What if it doesn\'t hit the target?',
            answer: 'Funds go toward building early tools for community use. If it ships, you get guaranteed lifetime access.'
        },
        {
            question: 'Can I get a refund?',
            answer: 'Nope. This is degen seed funding - stake your conviction.'
        },
        {
            question: 'Is it safe?',
            answer: 'Yes - your funds stay in your wallet. NyxBot helps you monitor, filter, and flash stake. Wallet integrations will be optional later.'
        }
    ];

    return (
        <section id="faq" className="py-24 bg-black">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-block px-6 py-3 bg-purple-500/10 border border-purple-500/30 rounded-full text-purple-300 text-lg font-semibold mb-4">
                        💬 FAQ
                    </span>
                    <h2 className="text-5xl md:text-6xl font-bold text-white">
                        Frequently Asked{' '}
                        <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                            Questions
                        </span>
                    </h2>
                </div>

                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="border border-purple-500/20 rounded-xl overflow-hidden hover:border-purple-500/40 transition-all"
                        >
                            <button
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                className="w-full px-6 py-4 flex items-center justify-between text-left bg-purple-500/5 hover:bg-purple-500/10 transition-colors"
                            >
                                <h3 className="text-lg font-semibold text-white">{faq.question}</h3>
                                <svg
                                    className={`w-5 h-5 text-purple-400 transition-transform ${
                                        openIndex === index ? 'rotate-180' : ''
                                    }`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                            {openIndex === index && (
                                <div className="px-6 py-4 bg-black/40">
                                    <p className="text-gray-300">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};